import type { AxiosInstance } from "axios";
import { USER_API } from "config";
import type { SessionUser } from "types/session-user";

type SessionUserPayload = {
  user: SessionUser;
};

type ApiEnvelope<T> = {
  data: T;
};

/**
 * Supports both:
 * - useAxios({ allResponse: true }) / raw axios → response.data.data.user
 * - useAxios() default interceptor (returns envelope) → response.data.user
 */
export const fetchSessionUser = async (axios: AxiosInstance): Promise<SessionUser> => {
  const response = await axios.get<ApiEnvelope<SessionUserPayload> | SessionUserPayload>(
    USER_API.me
  );

  const body = response.data as ApiEnvelope<SessionUserPayload> | SessionUserPayload | undefined;
  if (!body) {
    throw new Error("Invalid /users/me response: missing body");
  }

  if ("user" in body && body.user) {
    return body.user;
  }

  if ("data" in body && body.data?.user) {
    return body.data.user;
  }

  throw new Error("Invalid /users/me response: missing user");
};
